<p-toast /> <!-- messages area -->
@if(!deviceService.isMobile) {
    <!-- DESKTOP/TABLET -->
    @if(loading) {
        <div class="flex justify-center items-center h-screen">
            <i class="pi pi-spin pi-spinner cosa-color" style="font-size: 2rem;"></i>
        </div>
    } @else {
        <p-confirmdialog></p-confirmdialog> <!-- dialogs area -->
                <!-- chatbot drawer area -->
        @if(cosoDrawerFullScreen) {
            <p-drawer [(visible)]="chatBotDrawer" position="full" styleClass="coso-chat-drawer" (visibleChange)="onChatDrawerVisibleChange($event)">
                <app-coso-chat
                        [avatar]="getAvatar()"
                        [fullScreen]="cosoDrawerFullScreen"
                        (toggleFullScreen)="cosoDrawerFullScreen = !cosoDrawerFullScreen"
                        (closeChat)="chatBotDrawer = false"
                ></app-coso-chat>
            </p-drawer>
        } @else {
            <p-drawer [(visible)]="chatBotDrawer" position="right" styleClass="coso-chat-drawer w-3/4! lg:1/2! xl:w-1/3!" (visibleChange)="onChatDrawerVisibleChange($event)"> <!-- chatbot drawer area -->
                @if(chatBotDrawer) {
                    <app-coso-chat
                            [avatar]="getAvatar()"
                            [fullScreen]="cosoDrawerFullScreen"
                            (toggleFullScreen)="cosoDrawerFullScreen = !cosoDrawerFullScreen"
                            (closeChat)="chatBotDrawer = false"
                    ></app-coso-chat>
                }
            </p-drawer>
        }

        @if(user) {
            @if(layout === 'horizontal') {
                <div class="h-full">
                    <!-- Menubar -->
                    <div class="mb-4 horizontal-nav">
                        <p-menubar [model]="navItems" [dt]="MENUBAR">
                            <ng-template #start>
                                <img class="mx-4 h-[28px]" src="../assets/MAXI_logo_sm.png" height="28"  />
                            </ng-template>
                            <ng-template #item let-item let-root="root">
                                <a [routerLink]="item.url" pRipple class="flex items-center p-menubar-item-link">
                                    @if(item.icon) {
                                        <span [class]="item.icon"></span>
                                    }
                                    <span>{{ item.label }}</span>
                                    @if(item.items) {
                                        <i [ngClass]="['ml-auto pi', root ? 'pi-angle-down' : 'pi-angle-right']"></i>
                                    }
                                </a>
                            </ng-template>
                            <ng-template #end>
                                <div class="flex items-center gap-2">
                                    <span class="text-sm my-1 mr-1 app-title">v.{{appVersion}}</span>
                                    <p-button [dt]="BUTTON_NAV" icon="pi pi-ellipsis-v" [rounded]="false" [text]="true" severity="secondary"
                                              (click)="switchLayout()" size="large" pTooltip="Vertical Navbar" tooltipStyleClass="text-sm" tooltipPosition="bottom" showDelay="1000"/>
                                    @if(!darkMode) {
                                        <p-button [dt]="BUTTON_NAV" icon="pi pi-moon" [rounded]="false" [text]="true" severity="secondary"
                                                  (click)="switchTheme()" size="large" pTooltip="Dark Mode" tooltipStyleClass="text-sm" tooltipPosition="bottom" showDelay="1000" />
                                    } @else {
                                        <p-button [dt]="BUTTON_NAV" icon="pi pi-sun" [rounded]="false" [text]="true" severity="secondary"
                                                  (click)="switchTheme()" size="large" pTooltip="Light Mode" tooltipStyleClass="text-sm" tooltipPosition="bottom" showDelay="1000" />
                                    }
                                    @if(canOpenCosoChat()) {
                                        <p-button icon="pi pi-comment" [rounded]="false" [text]="true" severity="secondary" [dt]="BUTTON_NAV"
                                              (click)="chatBotDrawer = !chatBotDrawer" size="large" pTooltip="Personal Assistant" tooltipStyleClass="text-sm" tooltipPosition="bottom" showDelay="1000" />
                                    }
                                    @let notificationStatus = notificationService.getNotificationStatus();
                                    @if(notificationStatus) {
                                        <p-button icon="pi pi-bell" [rounded]="false" [text]="true" severity="secondary" [dt]="BUTTON_NAV"
                                                  (click)="notificationService.disableNotifications()" size="large" pTooltip="Push Notifications are enabled" tooltipStyleClass="text-sm" tooltipPosition="bottom" showDelay="1000" />
                                    } @else {
                                        <p-button icon="pi pi-bell-slash" [rounded]="false" [text]="true" severity="secondary" [dt]="BUTTON_NAV"
                                                  (click)="notificationService.enableNotifications()" size="large" pTooltip="Push Notifications are disabled" tooltipStyleClass="text-sm" tooltipPosition="bottom" showDelay="1000" />
                                    }
                                    <p-avatar [label]="getAvatar()" shape="circle" (click)="profileMenu.toggle($event)" class="cursor-pointer text-xs! ml-2" />
                                    <p-menu #profileMenu [model]="getProfileItems()" [popup]="true">
                                        <ng-template #item let-item>
                                            @if(item.route) {
                                                <a [routerLink]="item.route" class="p-menu-item-link">
                                                    <span [class]="item.icon"></span>
                                                    <span class="ml-2">{{ item.label }}</span>
                                                </a>
                                            } @else {
                                                <a [href]="item.url" class="p-menu-item-link">
                                                    <span [class]="item.icon"></span>
                                                    <span class="ml-2">{{ item.label }}</span>
                                                </a>
                                            }
                                        </ng-template>
                                    </p-menu>
                                </div>
                            </ng-template>
                        </p-menubar>
                    </div>
                    <!-- Outlet -->
                    <!-- old: <div class="flex flex-col grow mx-auto px-4">-->
                    <div class="h-[calc(100lvh-60px)] w-full px-4 overflow-auto">
                        <router-outlet></router-outlet>
                    </div>
                </div>
            } @else {
                <!-- VERTICAL LAYOUT -->
                <div class="flex w-full">
                    <div class="flex flex-col flex-shrink-0 justify-between h-screen vertical-nav sticky top-0 w-[54px] pt-1"
                         [class.w-[220px]]="sidebar === 'expanded'" [class.min-w-[220px]]="sidebar === 'expanded'">
                        <!-- Upper part -->
                        <div>
                            <!-- Title -->
                            <div class="flex flex-row items-center mt-3 mb-4 pl-2 app-title h-[20px]">
                                <div class="flex flex-row items-center gap-x-2">
                                    <p-button icon="pi pi-bars " [rounded]="true" [text]="false" severity="secondary" (click)="vnav.collapseAll(); collapseSideBar()"
                                              [pTooltip]="'Collapse Navigation Bar'" tooltipStyleClass="text-sm" [dt]="HAMBURGER_BTN"/>
                                    @if(sidebar === 'expanded') {
                                        <h2 class="font-semibold uppercase">{{appTitle}}</h2>
                                        @if(test) {
                                            <p-tag severity="warn" class="text-xs!" rounded>{{appVersion}}</p-tag>
                                        }@else {
                                            <span class="text-sm ml-2 pt-1">{{appVersion}}</span>
                                        }
                                    }
                                </div>

                            </div>
                            <!-- Menubar -->
                            <p-panelmenu [model]="navItems" multiple="true" class="w-full pt-1" [dt]="PANELMENU" #vnav >
                                <ng-template #item let-item>
                                    @if(sidebar === 'expanded') {
                                        <div class="mx-3 py-2 pl-0 pr-1" [routerLink]="item.url">
                                            <a [routerLink]="item.url" pRipple class="flex items-center p-menubar-item-link h-[21px] pl-1!">
                                                @if(item.icon) {
                                                    <span [class]="item.icon" class="mr-3" style="font-size: 16px"></span>
                                                }
                                                <span class="font-semibold">{{ item.label }}</span>
                                                @if(item.items) {
                                                    <i [ngClass]="['ml-auto pi', item.expanded ? 'pi-angle-down' : 'pi-angle-left']"></i>
                                                }
                                            </a>
                                        </div>
                                    } @else if(item.items) {
                                        <div class="py-2 pl-0 cursor-pointer" [pTooltip]="item.label" tooltipStyleClass="text-sm" [routerLink]="item.url" (click)="collapseSideBar()">
                                            <a [routerLink]="item.url" pRipple class="flex items-center p-menubar-item-link h-[21px] pl-4!">
                                                @if(item.icon) {
                                                    <span [class]="item.icon" style="font-size: 16px"></span>
                                                }
                                            </a>
                                        </div>
                                    } @else {
                                        <div class="py-2 pl-0 cursor-pointer" [pTooltip]="item.label" tooltipStyleClass="text-sm" [routerLink]="item.url">
                                            <a [routerLink]="item.url" pRipple class="flex items-center p-menubar-item-link h-[21px] pl-4!">
                                                @if(item.icon) {
                                                    <span [class]="item.icon" style="font-size: 16px"></span>
                                                }
                                            </a>
                                        </div>
                                    }
                                </ng-template>
                            </p-panelmenu>
                        </div>
                        <!-- Footer -->
                        <div class="w-full px-1 pb-5" [pTooltip]="logoutItem.label" tooltipStyleClass="text-sm">
                            <!--<p-divider class="mb-1!" />-->
                            <a class="p-menu-item-link app-title h-[37px]" (click)="logout()">
                                <span [class]="logoutItem.icon" style="font-size: 16px"></span>
                                @if(sidebar === 'expanded') {
                                    <span class="ml-2 font-semibold">{{ logoutItem.label }}</span>
                                }
                            </a>
                        </div>
                    </div>
                    <div class="flex flex-col flex-1 min-w-0 pb-4">
                        <!-- header -->
                        <div class="flex flex-row flex-shrink-0 justify-between items-center w-full px-4 border-b-1 mb-4 vertical-header">
                            <img class="mx-4 h-[25px]" src="../assets/MAXI_logo_sm.png"  />
                            <!--<div class="font-semibold uppercase mt-[4px]">COSA BackOffice</div>-->
                            <div class="flex flex-row items-center">
                                <p-button icon="pi pi-ellipsis-h" [rounded]="false" [text]="true" severity="secondary" [dt]="BUTTON_NAV"
                                          (click)="switchLayout()" size="large"  pTooltip="Horizontal Navbar" tooltipStyleClass="text-sm" tooltipPosition="bottom" showDelay="1000"/>
                                @if(!darkMode) {
                                    <p-button icon="pi pi-moon" [rounded]="false" [text]="true" severity="secondary" [dt]="BUTTON_NAV"
                                              (click)="switchTheme()" size="large" pTooltip="Dark Mode" tooltipStyleClass="text-sm" tooltipPosition="bottom" showDelay="1000"/>
                                } @else {
                                    <p-button icon="pi pi-sun" [rounded]="false" [text]="true" severity="secondary" [dt]="BUTTON_NAV"
                                              (click)="switchTheme()" size="large" pTooltip="Light Mode" tooltipStyleClass="text-sm" tooltipPosition="bottom" showDelay="1000"/>
                                }
                                @if(canOpenCosoChat()) {
                                    <p-button icon="pi pi-comment" [rounded]="false" [text]="true" severity="secondary" [dt]="BUTTON_NAV"
                                          (click)="chatBotDrawer = !chatBotDrawer" size="large" pTooltip="Personal Assistant" tooltipStyleClass="text-sm" tooltipPosition="bottom" showDelay="1000" />
                                }
                                @let notificationStatus = notificationService.notificationStatus;
                                @if(notificationStatus === 'granted') {
                                    <p-button icon="pi pi-bell" [rounded]="false" [text]="true" severity="secondary" [dt]="BUTTON_NAV"
                                              (click)="notificationService.disableNotifications()" size="large" pTooltip="Push Notifications are enabled" tooltipStyleClass="text-sm" tooltipPosition="bottom" showDelay="1000" />
                                } @else {
                                    <p-button icon="pi pi-bell-slash" [rounded]="false" [text]="true" severity="secondary" [dt]="BUTTON_NAV"
                                              (click)="notificationService.enableNotifications()" size="large" pTooltip="Push Notifications are disabled" tooltipStyleClass="text-sm" tooltipPosition="bottom" showDelay="1000" />
                                }
                                <p-avatar [label]="getAvatar()" shape="circle" (click)="profileMenu.toggle($event)" class="ml-3 cursor-pointer text-xs!" />
                                <p-menu #profileMenu [model]="getProfileItems()" [popup]="true">
                                    <ng-template #item let-item>
                                        @if(item.route) {
                                            <a [routerLink]="item.route" class="p-menu-item-link">
                                                <span [class]="item.icon"></span>
                                                <span class="ml-2">{{ item.label }}</span>
                                            </a>
                                        } @else {
                                            <a [href]="item.url" class="p-menu-item-link">
                                                <span [class]="item.icon"></span>
                                                <span class="ml-2">{{ item.label }}</span>
                                            </a>
                                        }
                                    </ng-template>
                                </p-menu>
                            </div>
                        </div>
                        <!-- Outlet -->
                        <div class="h-[calc(100lvh-60px)] w-full px-4 overflow-auto">
                            <router-outlet></router-outlet>
                        </div>
                    </div>
                </div>
            }
        } @else if(user === null) {
            <app-login></app-login>
        }
    }
} @else {
    <!-- MOBILE -->
    @if(loading) {
        <div class="flex justify-center items-center h-screen">
            <i class="pi pi-spin pi-spinner cosa-color" style="font-size: 2rem;"></i>
        </div>
    } @else {
        <p-confirmdialog [style]="{ width: '90vw' }"></p-confirmdialog> <!-- dialogs area -->
        @if(user) {
            <div class="h-full overflow-scroll">
                <!-- Menubar -->
                <div class="mobile-nav sticky top-0 z-95">
                    <p-menubar [model]="navItems" [dt]="MENUBAR_MOBILE" class="mobile-menu-left">
                        <ng-template #start>
                            <div class="flex flex-row grow items-center justify-center">
                                <img class="ml-14 h-[20px] brightness-0 opacity-60 dark:brightness-100 dark:opacity-100" src="../assets/MAXI_logo_sm.png" height="20"  />
                            </div>
                        </ng-template>
                        <ng-template #item let-item let-root="root">
                            <a [routerLink]="item.url" pRipple class="flex items-center p-menubar-item-link">
                                @if(item.icon) {
                                    <span [class]="item.icon"></span>
                                }
                                <span>{{ item.label }}</span>
                                @if(item.items) {
                                    <i [ngClass]="['ml-auto pi', root ? 'pi-angle-down' : 'pi-angle-right']"></i>
                                }
                            </a>
                        </ng-template>
                        <ng-template #end>
                            <div class="flex items-center gap-2">
                                <!--@if(!darkMode) {
                                    <p-button [dt]="BUTTON_NAV_MOBILE" icon="pi pi-moon" [rounded]="false" [text]="true" severity="secondary"
                                              (click)="switchTheme()" size="large" pTooltip="Dark Mode" tooltipStyleClass="text-sm" tooltipPosition="bottom" showDelay="1000" />
                                } @else {
                                    <p-button [dt]="BUTTON_NAV_MOBILE" icon="pi pi-sun" [rounded]="false" [text]="true" severity="secondary"
                                              (click)="switchTheme()" size="large" pTooltip="Light Mode" tooltipStyleClass="text-sm" tooltipPosition="bottom" showDelay="1000" />
                                }
                                -->
                                <p-avatar [dt]="AVATAR_MOBILE" [label]="getAvatar()" shape="circle" (click)="profileMenu.toggle($event)" class="cursor-pointer text-xs! ml-2" />
                                <p-menu #profileMenu [model]="getProfileItems()" [popup]="true">
                                    <ng-template #item let-item>
                                        @if(item.route) {
                                            <a [routerLink]="item.route" class="p-menu-item-link">
                                                <span [class]="item.icon"></span>
                                                <span class="ml-2">{{ item.label }}</span>
                                            </a>
                                        } @else {
                                            <a [href]="item.url" class="p-menu-item-link">
                                                <span [class]="item.icon"></span>
                                                <span class="ml-2">{{ item.label }}</span>
                                            </a>
                                        }
                                    </ng-template>
                                </p-menu>
                            </div>
                        </ng-template>
                    </p-menubar>
                </div>
                <!-- Outlet -->
                <div class="h-[calc(100lvh-60px)] mx-auto">
                    <router-outlet></router-outlet>
                </div>
            </div>
        } @else if(user === null) {
            <app-login></app-login>
        }
    }
}
